<i18n>
{
"en": {
  "DRIVERS": "Drivers",
  "MANAGEDRIVERS": "Manage Drivers",
  "DRIVERID": "Driver ID",
  "LICENCE": "Licence",
  "EDITDRIVER": "Edit Driver",
  "ADDNEWDRIVER": "Add New Driver",
  "UPLOADCSVFILE": "Upload CSV File",
  "CHOOSEFILTERBY": "Choose Filer By",
  "SEARCHNAME": "Search Name",
  "SEARCHID": "Search ID",
  "SERACHBYNATIONALITY": "Serach By Nationality",
  "LOADING": "Loading...",
  "NAME": "Name",
  "LICENSEEXPIRATION": "License Expiration",
  "NATIONALITY": "Nationality",
  "STATUS": "Status",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "DEACTIVATEDRIVER": "Deactivate Driver",
  "ACTIVATEDRIVER": "Activate Driver",
  "ID": "ID",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISDRIVER": "restore this driver?",
  "DEACTIVATETHISDRIVER": "deactivate this driver?",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "LICENCEIMAGE": "Licence Image",
  "CLOSE": "Close",
  "DRIVERNAME": "Driver Name",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "EMAILADDRESS": "Email Address",
  "GENDER": "Gender",
  "IDENTIFICATIONNUMBER": "Identification Number",
  "IDEXPIRATIONDATE": "ID Expiration Date",
  "MOBILEPHONE": "Mobile Phone",
  "LANDLINEPHONE": "LandlinePhone",
  "DRIVERCANNOTBEDEACTIVATED": "Driver cannot be deactivated! Already assigned to a route.",
  "DRIVERHASBEEN": "Driver has been",
  "RESTORED": "restored!",
  "DEACTIVATED": "deactivated!",  
  "DRIVERHASNOTBEENDELETED": "Driver has not been deleted!",
  "ASSIGNEDTOBUS": "Assigned to bus",
  "ASSIGNED": "Assigned",
  "NOTASSIGNED":"Not assigned",
  "ROUTENAME": "Route Name",
  "FILTERBYROUTE": "Filter by route",
  "SENDREGISTRATIONCODE": "Send Registration Code",
  "REGISTRATIONHASBEENSENT": "Registration has been sent!!"
},
"ar": {
  "DRIVERS": "السائقين",
  "MANAGEDRIVERS": "إدارة السائقين",
  "DRIVERID": "تعريف السائق",
  "LICENCE": " رخصة",
  "EDITDRIVER": "تحرير السائق",
  "ADDNEWDRIVER": "اضافة سائق جديد",
  "UPLOADCSVFILE": "تحميل ملف CSV",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "SEARCHNAME": "ابحث عن الإسم",
  "SEARCHID": " ابحث عن الهوية",
  "SERACHBYNATIONALITY": "البحث حسب الجنسية",
  "LOADING": "جار التحميل...",
  "NAME": "الاسم",
  "LICENSEEXPIRATION": "انتهاء صلاحية الرخصة",
  "NATIONALITY": "الجنسية",
  "STATUS": "الحالة",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "DEACTIVATEDRIVER": "تعطيل السائق",
  "ACTIVATEDRIVER": "تفعيل السائق",
  "ID": "الهوية",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISDRIVER": "استعادة هذا السائق؟",
  "DEACTIVATETHISDRIVER": "تعطيل هذا السائق؟",
  "CANCEL": "الغاء",
  "CONFIRM": "تأكد",
  "LICENCEIMAGE": "صورة الرخصة",
  "CLOSE": "أغلق",
  "DRIVERNAME": "اسم السائق",
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "LASTNAME(ARABIC)": "الإسم العائلي(عربي) ",
  "FIRSTNAME": "الأسم الأول",
  "LASTNAME": "اسم العائلة",
  "STUDENTID": "هوية الطالب",
  "EMAILADDRESS": "عنوان البريد الإلكتروني",
  "GENDER": "الجنس",
  "IDENTIFICATIONNUMBER": "رقم الهوية",
  "IDEXPIRATIONDATE": "انتهاء صلاحية الهوية",
  "MOBILEPHONE": "الهاتف المحمول",
  "DRIVERCANNOTBEDEACTIVATED": ".لا يمكن تعطيل !السائق لديه طريق مخصص",
  "DRIVERHASBEEN": "كان السائق",
  "RESTORED": "رمم!",
  "DEACTIVATED": "معطلة!", 
  "DRIVERHASNOTBEENDELETED": "لم يتم حذف برنامج التشغيل!",
  "ASSIGNEDTOBUS": "مشارك في الحافلة",
  "ASSIGNED": "مشارك",
  "NOTASSIGNED":"غيرمعتمد",
  "ROUTENAME": "اسم المسار",
  "FILTERBYROUTE": "اختر حسب خط السير",
  "SENDREGISTRATIONCODE": "ارسل رمز التسجيل",
  "REGISTRATIONHASBEENSENT": "تم إرسال  رمز التسجيل!!"
}
}
</i18n>
<template>
  <div>
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('MANAGEDRIVERS')}}</span>
        <el-dropdown trigger="click" type="dark">
          <el-button-group>
            <el-button @click="$router.push({path:'/transportation/driver/create'})" :disabled="!isAllowed('save')">
               <i class="el-icon-plus"></i> {{$t('ADDNEWDRIVER')}}
            </el-button>
            <el-button ref="trigger" class="el-dropdown__caret-button">
              <i class="el-dropdown__icon el-icon-caret-bottom"></i>
            </el-button>
          </el-button-group>          
          <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :disabled="!isAllowed('import')">       
          <el-upload
            ref="upload"
            accept=".csv"
            class="upload-demo"
            :action="URL + 'media/upload'"
            :data="import_data"
            :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
            :with-credentials="true"
            :on-success="uploadedFile">
            <i class="fa fa-upload"></i> {{$t('UPLOADCSVFILE')}}
          </el-upload>   
          </el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>      
      </div>

      <div class="filters" ref="filter">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select  v-model="filter" @change="changedFilter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="active_filter=='name'">
            <el-input :placeholder="$t('SEARCHNAME')" v-model="FullName" :icon="FullName ? 'circle-close' : ''" @click="clearInput"></el-input> 
          </el-col>
          <el-col :span="4" v-if="active_filter=='id'">
            <el-input :placeholder="$t('SEARCHID')" v-model="PersonID" :icon="PersonID ? 'circle-close' : ''" @click="clearInput"></el-input>
          </el-col>
         <el-col :span="5"  v-if="active_filter=='nationality'">
             <el-select :disabled="loading"  v-model="Nationality" :placeholder="$t('SERACHBYNATIONALITY')" :filterable="true" clearable>
               <el-option :key="key" v-for="(item, key) in $countries" :label="item" :value="key"></el-option>
            </el-select>         
           </el-col>          
        </el-row>
      </div>
      <el-table
       v-loading="loading"   
        :element-loading-text="$t('LOADING')"
        :data="listDrivers"
        highlight-current-row
        @current-change="handleCurrentChange"
        :height="tableHeight"
        stripe
        style="width: 100%">
        <el-table-column
          prop="ExternalPersonID"
          :label="$t('ID')"
          min-width="150"
          class="center"
          align="left"
          sortable>
        </el-table-column>
        <el-table-column
          :label="$t('NAME')"
          min-width="200"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath)" alt="" class="img-circle">
             {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}
          </template>
        </el-table-column>
                <el-table-column
          prop="LicenseExpiration"
          :label="$t('LICENSEEXPIRATION')"
          min-width="160"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column
          :label="$t('NATIONALITY')"
          min-width="150"
          align="left"
          sortable>
          <template slot-scope="scope">
            {{$countries[scope.row.Nationality]}}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('LICENCE')" min-width="120">
            <template slot-scope="scope">
              <el-popover
                ref="popLicense"
                placement="left"
                width="250"
                trigger="hover">
                <img :src="getAsset(scope.row.LicenseImage, 'license')" style="width: 100%;">
              </el-popover>
              <el-button @click="viewLicence(scope.row.LicenseImage)" v-popover:popLicense size="small"><i class="fa fa-sticky-note"></i> {{$t('LICENCE')}}</el-button>                          
            </template>
        </el-table-column>
        <el-table-column
          prop="Status"
          :label="$t('STATUS')"
          min-width="100"
          align="center"
          sortable>

          <template slot-scope="scope">
              <el-tag
                :type="parseInt(scope.row.Status) !== 1  ? 'success' : 'danger'"
                close-transition>{{parseInt(scope.row.Status) !== 1 ? $t('ACTIVE') : $t('INACTIVE')}}</el-tag>
          </template>

        </el-table-column>

         <el-table-column
            :label="$t('ASSIGNEDTOBUS')"
            min-width="160"
            align="center"
            sortable>
            <template slot-scope="scope">
              <el-tag
                type="primary"
                close-transition>{{scope.row.RouteID !== null ? $t('ASSIGNED') : $t('NOTASSIGNED')}}</el-tag>
            </template>
          </el-table-column>
        <el-table-column
          align="center"
          class="actions"
          min-width="120">

          <template slot-scope="scope">
              <el-tooltip v-if="isAllowed('registration') && scope.row.EMail" :content="$t('SENDREGISTRATIONCODE')" placement="top">
                <el-button :disabled="scope.row.BusDriverID === sending" type="text" @click="sendRegistration(scope.row)"><i class="fa" :class="[scope.row.BusDriverID !== sending ? 'fa-key' : 'fa-circle-o-notch fa-spin']"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('save')" :content="$t('EDITDRIVER')" placement="top">
                <el-button type="text" @click="$router.push({path:'/transportation/driver/'+scope.row.PersonID})"><i class="fa fa-pencil"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('delete')" :disabled="scope.row.RouteID!=null ? true : false" :content="drivers[scope.$index].Status==0 ? $t('DEACTIVATEDRIVER') : $t('ACTIVATEDRIVER')" placement="top">                          
                <el-popover
                  trigger="manual"
                  placement="left"
                  width="160"
                  @show="driver=drivers[scope.$index]"
                  v-model="drivers[scope.$index].Deleted">
                 <p> {{$t('AREYOUSUREYOUWANTTO') + ' '}}{{drivers[scope.$index].Status==0 ? $t('DEACTIVATETHISDRIVER') : $t('RESTORETHISDRIVER')}}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="drivers[scope.$index].Deleted = false">{{$t('CANCEL')}}</el-button>
                    <el-button type="primary" size="mini" @click="toggleStatus(scope.$index)">{{$t('CONFIRM')}}</el-button>
                  </div>
                  <el-button :disabled="scope.row.RouteID!=null" style="margin-left:10px" type="text" @click="drivers[scope.$index].Deleted=true" slot="reference"><i class="fa" :class="[scope.row.Status!= 0 ? 'fa-undo' : 'fa-times']"></i> </el-button>
                </el-popover>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-import-dialog @reCall="reCall" :visible.sync="dialogImport" :fields="fields" :title="$t('DRIVERS')" uri="driver/import" :CSVReader="CSVReader" :CSVFile="CSVFile"></el-import-dialog>          
    <el-dialog
  :title="$t('LICENCEIMAGE')"
  :visible.sync="dialogVisible"
>
  <div align="center">
  <img  :src="getAsset(LicenseImage, 'license')" style="width:100%">
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
  
  import ImportDialog from '@/components/dialogs/Import'
  export default {
    components: {'el-import-dialog': ImportDialog},
    data () {
      return {
        drivers: [],
        routes: [],
        driver: {Deleted: false},
        currentRow: null,
        tableHeight: 0,
        filter: null,
        active_filter: 'name',
        loading: true,
        indexCheck: null,
        prevIndex: null,
        FullName: '',
        PersonID: '',
        Nationality: '',
        LicenseImage: {},
        dialogVisible: false,
        CSVReader: {},
        CSVFile: '',
        dialogImport: false,
        sending: null,
        import_data: {}
      }
    },
    mounted () {
      this.switchLanguage()
      this.import_data = {folder: this.$route.path.split('/')[2], type: 'import'}
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + 53)
      this.getDrivers()
    },
    computed: {
      listDrivers () {
        let drivers = this.drivers
        if (this.active_filter === 'name') drivers = this.filterBy(drivers, this.FullName, ['FullName_EN', 'FullName_AR'])
        if (this.active_filter === 'id') drivers = this.filterBy(drivers, this.PersonID, 'ExternalPersonID')
        if (this.active_filter === 'nationality') drivers = this.filterBy(drivers, this.Nationality, 'Nationality')
        return drivers
      },
      options () {
        let options = [{
          value: 'name',
          label: this.$t('DRIVERNAME')
        }, {
          value: 'id',
          label: this.$t('DRIVERID')
        }, {
          value: 'nationality',
          label: this.$t('NATIONALITY')
        }]
        return options
      },
      fields () {
        let fields = [
          {label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null},
          {label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null},
          {label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null},
          {label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null},
          {label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null},
          {label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null},
          {label: this.$t('GENDER'), field: 'Gender', required: true, format: null},
          {label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null},
          {label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null},
          {label: this.$t('LICENSEEXPIRATION'), field: 'LicenseExpiration', required: true, format: 'date'},
          {label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: true, format: 'date'},
          {label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null},
          {label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null},
          {label: this.$t('EMAILADDRESS'), field: 'EMail', required: false, format: null}
        ]
        return fields
      }
    },
    methods: {
      getDrivers () {
        let self = this
        if (!self.loading) return
        this.$http.get('/driver')
          .then(function (response) {
            for (let driver in response.data) {
              response.data[driver].Deleted = false
            }
            self.drivers = response.data
            self.loading = false
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      sendRegistration (driver) {
        let postData = {}
        let self = this
        postData.driver = {FullName: driver.FullName_EN.replace(' ', ''), email: driver.EMail, BusDriverID: driver.BusDriverID}
        this.sending = driver.BusDriverID
        this.$http.post('/registration', postData).then(function (response) {
          self.sending = null
          self.$message({
            message: self.$t('REGISTRATIONHASBEENSENT'),
            type: 'success',
            showClose: true
          })
        }).catch(function () {
        })
      },
      reCall () {
        this.loading = true
        this.getDrivers()
      },
      currentLang () {
        return localStorage.getItem('lang')
      },
      filterBy (arr, search, delimiter) {
        if (!search) return arr
        let res = []
        arr.filter(function (el) {
          if (typeof delimiter === 'object') {
            let regx = new RegExp('(?:^|\\s)' + search, 'ig')
            if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el)
          } else {
            search = '^' + search
            if (new RegExp(search, 'i').test(el[delimiter])) res.push(el)
          }
        })
        return res
      },
      removeFilter (filter) {
        this.changeFilter()
        this.filter = ''
        this.listDrivers
      },
      changeFilter () {
        this.FullName = this.PersonID = this.Nationality = ''
      },
      handleCurrentChange (val) {
        this.currentRow = val
      },
      toggleStatus (index) {
        let self = this
        let postData = {PersonID: self.drivers[index].PersonID, Status: self.drivers[index].Status}
        this.$http.post('/driver/delete', postData)
          .then(function (response) {
            self.drivers[index].Deleted = false
            self.drivers[index].DeletedAT = self.drivers[index].DeletedAT !== null ? null : ''
            self.drivers[index].Status = self.drivers[index].Status === '1' ? '0' : '1'
            if (self.drivers[index].Status === '1') self.drivers.push(self.drivers.splice(index, 1)[0])
            self.$message({
              message: response.data.error ? self.$t('DRIVERHASNOTBEENDELETED') : self.$t('DRIVERHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
              type: response.data.error ? 'error' : 'success',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      checkRoute (index) {
        let self = this
        if (self.drivers[index].Status === '1') {
          self.drivers[index].Deleted = true
          return
        }
        if (self.prevIndex !== null) self.drivers[self.prevIndex].Deleted = false
        if (self.indexCheck === self.drivers[index].BusDriverID) return
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
      },
      viewLicence (image) {
        this.LicenseImage = image
        this.dialogVisible = true
      },
      clearInput () {
        this.FullName = this.PersonID = ''
        this.listDrivers
      },
      uploadedFile (response, file, fileList) {
        if (response.error) {
          return this.$message({
            message: response.error,
            type: 'error',
            showClose: true
          })
        }
        this.CSVReader = response.fields
        this.CSVFile = response.file_name
        this.dialogImport = true
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Driver.vue?7c625fe1